module.exports = __webpack_public_path__ + "img/ic_star_default.747e4410.svg";